<template>
  <page-wrapper :title="pageWrapper.title" :has-pad="pageWrapper.hasPad">
    <div
      v-for="(projects, projectIndex) in stations"
      :key="projectIndex"
      class="project-container"
    >
      <div
        v-for="(station, stationIndex) in projects"
        :key="stationIndex"
        class="station-row"
      >
        <h4 v-if="stationIndex === 0">
          {{ station.project.project_name }}
          <router-link
            :to="station.report_url"
            class="link back-page"
            target="_blank"
            ><sc-button variant="primary"
              >ดูรายงานการใช้</sc-button
            ></router-link
          >
        </h4>
        <el-row>
          <el-col :span="6"
            ><div class="grid-content">{{ station.name }}</div></el-col
          >
          <el-col :span="18">
            <div v-if="station.current_session === null" class="grid-content">
              ว่าง
            </div>
            <div v-if="station.current_session !== null" class="grid-content">
              <el-col :span="5">
                <el-row class="grid-current-session">เลขทะเบียนรถ</el-row>
                <el-row>{{ station.current_session.car_license }}</el-row>
              </el-col>
              <el-col :span="5">
                <el-row class="grid-current-session">รุ่นรถ</el-row>
                <el-row>{{ station.current_session.car_name }}</el-row>
              </el-col>
              <el-col :span="5">
                <el-row class="grid-current-session">เวลาเข้า</el-row>
                <el-row>{{
                  station.current_session.started_at | momentDatetime
                }}</el-row>
              </el-col>
              <el-col :span="5">
                <el-row class="grid-current-session">ปริมาณไฟ</el-row>
                <el-row
                  >{{ station.current_session.total_kwh }}/{{
                    station.current_session.current_accu_kwh
                  }}</el-row
                >
              </el-col>
              <el-col :span="4">
                <button
                  class="btn sc-btn sc-btn-opaque"
                  @click="stopButtonHandler(station.current_session.id)"
                >
                  <span>Stop&Exit</span>
                </button>
              </el-col>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { Row, Col } from "element-ui"
import ScButton from "@/lib/components/ScButton"
import { evUseCase } from "../EvUseCase"
import PageWrapper from "../../../lib/components/PageWrapper"

export default {
  name: "EvOverviewPage",
  components: {
    PageWrapper,
    "el-row": Row,
    "el-col": Col,
    ScButton,
  },
  data() {
    const pageWrapper = {
      title: "EV Parking",
      hasPad: true,
    }
    const stations = []
    return {
      pageWrapper,
      stations,
    }
  },
  created() {
    this.setup()
  },
  methods: {
    async setup() {
      this.setupStationData()
    },
    async stopButtonHandler(sessionId) {
      await evUseCase.stopAndExit(sessionId)
      this.setupStationData()
    },
    async setupStationData() {
      const projectWithStations = await evUseCase.getStations()
      this.stations = projectWithStations.map((project) =>
        project.map((station) => ({
          ...station,
          report_url: {
            name: "EvReportPage",
            query: { projectId: station.project.project_id },
          },
        })),
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.station-row {
  margin-bottom: 5px;
  &:last-child {
    margin-bottom: 0;
  }
}
.project-container {
  margin-bottom: 25px;
  &:last-child {
    margin-bottom: 0;
  }
}
.grid-current-session {
  border-bottom: 1px solid;
  border-color: #d3dce6;
  margin-right: 5px;
}
.grid-content {
  padding: 5px;
  border: 1px solid;
  border-color: #d3dce6;
  min-height: 64px;
}
</style>
